module.exports = __webpack_public_path__ + "static/media/create-audio.653fd56b.gif";